export const channelInputs = (state) => state.channel.channelUpdateInputs;
export const currentProject = (state) => state.channel.currentProject;
export const currentChannel = (state) => state.channel.currentChannel;
export const currentChannelVideo = (state) => state.channel.currentChannelVideo;
export const currentUser = (state) => state.auth.user;
